// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer{padding:30px 0 45px!important;background:#36134a!important}.footer-container{height:100%}@media(max-width:1279px)and (min-width:768px){.footer-container{padding:0 80px!important}}", ""]);
// Exports
module.exports = exports;
